// SYLES
//import './_index.scss'
import '../data/code/landing.scss'

// LIBS
import React from "react"

// HELPERS
let prefixLink = (url) => url

// COMPONENTS
import MetaData from '../components/meta-data'
import IndexContent from '../data/code/landing.js'

// INTERFACE
class Index extends React.Component {
  render(){
    return (
      <div className='wrapper'>
      <MetaData data={{
        slug: '',
        title: 'Premier Tech Academy | Discover a Rewarding New Career | Code Fellows',
        description: 'Code Fellows is the Pacific Northwest’s premier technical skills training academy, delivering high-quality live instruction both online and in person to people from all backgrounds.',
      }}/>
      <IndexContent />
      </div>
    )
  }
}

module.exports = Index



// WEBPACK FOOTER //
// ./src/pages/index.js